import { render, staticRenderFns } from "./PalletAdmin.vue?vue&type=template&id=fa5c5d88&scoped=true&"
import script from "./PalletAdmin.vue?vue&type=script&lang=js&"
export * from "./PalletAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PalletAdmin.vue?vue&type=style&index=0&id=fa5c5d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5c5d88",
  null
  
)

export default component.exports